import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function TimeOff(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "TimeOff", sx, viewBox, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M6 17.74h36v20.347a3.13 3.13 0 0 1-3.13 3.13H9.13A3.13 3.13 0 0 1 6 38.087V17.74Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M9.13 9.913h29.74a3.13 3.13 0 0 1 3.13 3.13v4.696H6v-4.696a3.13 3.13 0 0 1 3.13-3.13Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M17.738 6h-1.565c-.865 0-1.566.7-1.566 1.565v4.696c0 .864.701 1.565 1.566 1.565h1.565c.864 0 1.565-.7 1.565-1.565V7.565c0-.864-.7-1.565-1.565-1.565Zm14.089 0H30.26c-.864 0-1.565.7-1.565 1.565v4.696c0 .864.701 1.565 1.566 1.565h1.565c.864 0 1.565-.7 1.565-1.565V7.565c0-.864-.7-1.565-1.565-1.565Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M24.001 38.087a8.609 8.609 0 1 0 0-17.217 8.609 8.609 0 0 0 0 17.217Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M42 17.74H6v1.565h36v-1.566Z", fill: theme.vars.palette.secondary.main }),
    /* @__PURE__ */ jsx(
      "rect",
      {
        fill: theme.vars.palette.secondary.main,
        height: "8",
        rx: ".75",
        transform: "rotate(-45 21 27.06)",
        width: "1.5",
        x: "21",
        y: "27.061"
      }
    ),
    /* @__PURE__ */ jsx(
      "rect",
      {
        fill: theme.vars.palette.secondary.main,
        height: "8",
        rx: ".75",
        transform: "rotate(45 26.657 26)",
        width: "1.5",
        x: "26.657",
        y: "26"
      }
    )
  ] });
}
TimeOff.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "TimeOff"
};
validateTidalLicense();
export {
  TimeOff
};
//# sourceMappingURL=TimeOff.js.map
